import script from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeightedTokenPill.vue?vue&type=script&setup=true&lang=ts"

import "./WeightedTokenPill.vue?vue&type=style&index=0&id=549dab5b&scoped=true&lang=css"

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-549dab5b"]])

export default __exports__